module.exports = __webpack_public_path__ + "media/images/flags/sj-6d8f6e6625606a8751311c0bde3c7bcc.svg";